import { render } from "./RedirectView.vue?vue&type=template&id=55899b73&ts=true"
import script from "./RedirectView.vue?vue&type=script&lang=ts"
export * from "./RedirectView.vue?vue&type=script&lang=ts"

import exportComponent from "/frontside/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__